import { useNavigate } from "react-router-dom";
import { getApiClient, initializeApiClient } from "../apiService";

const  UpdatestateApplicationInformationPage = async (iP_InformationAboutProjectUpdateData,PersonalInformationModel,aI_BeneficiaryInformationModel,aI_GeneralInformationModel) => {
 //console.log(iP_InformationAboutProjectUpdateData,PersonalInformationModel,aI_BeneficiaryInformationModel,aI_GeneralInformationModel,"polkolkolkolkii");
 
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/InformationAboutProject/UpdatestateApplicationInformationPage`,
    {
      aI_ApplicationInformationUpdateData: iP_InformationAboutProjectUpdateData,
      aI_PersonalInformationModel:PersonalInformationModel,
        aI_BeneficiaryInformationModel:aI_BeneficiaryInformationModel,
        aI_GeneralInformationModel:aI_GeneralInformationModel
    }
  );
  

  return response.data.result;
};

export default UpdatestateApplicationInformationPage;
